import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeHtml',
})

export class DecodeHtmlPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value && value.length > 0) {
      const dom = new DOMParser().parseFromString(value, 'text/html');
      return dom.body.textContent;
    }
    return '';
  }
}
